const DEFAULT_POSITION = [12.5674, 41.8719];
const DEFAULT_ZOOM = 5;
const SERVER = "https://gna-proxy.przybylski-adrian.workers.dev";

export { DEFAULT_POSITION, DEFAULT_ZOOM, SERVER };
